import React from 'react';
import { modelClass } from '/imports/api/blacklists';
import { ModelFormPage } from '/imports/ui/ModelFormPage';

export const BlacklistPage = () => (
  <ModelFormPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    formSpec={() => [[{ field: 'username', label: 'Username' }]]}
  />
);
